var _rect, _path, _rect2, _rect3, _rect4, _path2, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWesternMedicineImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 112,
    viewBox: "0 0 125 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 48,
    width: 47,
    height: 94,
    rx: 23.5,
    transform: "rotate(90 121 48)",
    fill: "#EBF4FF",
    stroke: "#1C4270",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113 71.5C113 62.3873 105.613 55 96.5 55L69 55L69 88L96.5 88C105.613 88 113 80.6127 113 71.5Z",
    fill: "#5D9BE7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 80,
    width: 4,
    height: 13,
    rx: 2,
    transform: "rotate(90 88 80)",
    fill: "#EBF4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 80,
    width: 4,
    height: 5,
    rx: 2,
    transform: "rotate(90 96 80)",
    fill: "#EBF4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.125,
    y: 5.65685,
    width: 47,
    height: 94,
    rx: 23.5,
    transform: "rotate(45 72.125 5.65685)",
    fill: "#EBF4FF",
    stroke: "#1C4270",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0852 27.9307C76.6416 21.487 66.1944 21.487 59.7507 27.9307L40.3053 47.3761L63.6398 70.7106L83.0852 51.2652C89.5289 44.8216 89.5289 34.3743 83.0852 27.9307Z",
    fill: "#5D9BE7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 71.418,
    y: 51.6188,
    width: 4,
    height: 13,
    rx: 2,
    transform: "rotate(45 71.418 51.6188)",
    fill: "#EBF4FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0747,
    y: 45.9619,
    width: 4,
    height: 5,
    rx: 2,
    transform: "rotate(45 77.0747 45.9619)",
    fill: "#EBF4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWesternMedicineImage);
export default __webpack_public_path__ + "static/media/western_medicine_image.190c120b5f666c5ad88e7aeed3e7ad8d.svg";
export { ForwardRef as ReactComponent };